import { apiSlice } from '../../store/api/apiSlice';

interface SelfFeatureFlagsResponse {
  subject: {
    person_id: string;
    roles: string[];
  };
  flags: string[];
  globally_enabled_flags: string[];
  source: string;
}

export const featureFlagReadApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSelfFeatureFlags: builder.query<SelfFeatureFlagsResponse, string | null>({
      // The identity argument is a cache key only; authorization still comes
      // from the active bearer token configured by apiSlice.
      query: () => '/feature-flags/self',
    }),
  }),
});

export const { useGetSelfFeatureFlagsQuery } = featureFlagReadApi;
